import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      imgType: null,
      image: {
        top: '/uploads/mv/mv.jpg',
        inside: '/uploads/mv/inside.jpg'
      }
    };
  },
  mounted: function mounted() {
    this.checkType();
  },
  methods: {
    checkType: function checkType() {
      switch (true) {
        // トップページ用
        case location.pathname == '/':
        case location.pathname == '/index.html':
        case location.pathname == '/_sample/top.html':
          this.imgType = 'is-large';
          break;
        // フォーム

        case document.querySelectorAll("div[id^='aform']").length > 0:
        case new RegExp("^/contact").test(location.pathname):
          break;

        default:
          this.imgType = 'is-medium';
          break;
      }
    }
  }
};